import React, { Dispatch, SetStateAction, useState } from "react";
import {
  Button,
  CircularProgress,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import { LuMoreVertical } from "react-icons/lu";
import ModalImportExcel from "../../../components/common/modal/ModalImportExcel";
import ModalDuplicateRow from "../../../components/common/modal/ModalDuplicateRow";
import { CategoryType } from "../../../types/category.type";
import ModalExportExcel from "../../../components/common/modal/ModalExportExcel";

interface IOptions {
  category: CategoryType;
  setLoad: Dispatch<SetStateAction<number>>;
}

function Options({ category, setLoad }: IOptions) {
  const [anchorMenu, setAnchorMenu] = useState<HTMLButtonElement | null>(null);
  const [openImportExcel, setOpenImportExcel] = useState(false);
  const [openExportExcel, setOpenExportExcel] = useState(false);
  const [openModalDuplicate, setOpenModalDuplicate] = useState(false);

  const [exportLoading, setExportLoading] = useState<boolean>(false);
  const [importLoading, setImportLoading] = useState<boolean>(false);

  const handleCloseMenu = () => {
    setAnchorMenu(null);
  };

  return (
    <>
      {openImportExcel && (
        <ModalImportExcel
          open={openImportExcel}
          handleClose={() => setOpenImportExcel(false)}
          apiCode={category?.apiCode}
          setLoad={setLoad}
          loading={importLoading}
          setLoading={setImportLoading}
          columns={category?.columns}
        />
      )}
      {openExportExcel && (
        <ModalExportExcel
          loading={exportLoading}
          setLoading={setExportLoading}
          apiCode={category.apiCode}
          open={openExportExcel}
          handleClose={() => setOpenExportExcel(false)}
          filenameExport={`export_${category.apiCode}.xlsx`}
        />
      )}
      {openModalDuplicate && (
        <ModalDuplicateRow
          apiCode={category?.apiCode}
          open={openModalDuplicate}
          onClose={() => setOpenModalDuplicate(false)}
          columns={category.columns}
          fields={category?.fields || []}
        />
      )}
      {/* Anchor export excel */}
      {exportLoading && (
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          sx={{
            position: "fixed",
            zIndex: 100,
            bottom: 0,
            right: "5%",
            px: 2,
            py: 1,
            backgroundColor: "secondary.main",
            borderRadius: "10px 10px 0px 0px",
          }}
        >
          <Typography sx={{ color: "common.white" }}>
            Xuất {`${category?.apiCode}_export.xlsx`}
          </Typography>
          <CircularProgress
            style={{ width: "20px", height: "20px" }}
            sx={{ color: "common.white" }}
          />
        </Stack>
      )}
      {/* Anchor import excel */}
      {importLoading && (
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          sx={{
            position: "fixed",
            zIndex: 100,
            bottom: 0,
            right: "5%",
            px: 2,
            py: 1,
            backgroundColor: "secondary.main",
            borderRadius: "10px 10px 0px 0px",
          }}
        >
          <Typography sx={{ color: "common.white" }}>
            Đang nhập file excel
          </Typography>
          <CircularProgress
            style={{ width: "20px", height: "20px" }}
            sx={{ color: "common.white" }}
          />
        </Stack>
      )}
      <Menu open={!!anchorMenu} anchorEl={anchorMenu} onClose={handleCloseMenu}>
        <MenuItem onClick={() => setOpenImportExcel(true)}>Nhập excel</MenuItem>
        <MenuItem onClick={() => setOpenExportExcel(true)}>Xuất excel</MenuItem>
        {/* <MenuItem onClick={() => setOpenModalDuplicate(true)}>
          Kiểm tra trùng dữ liệu
        </MenuItem> */}
      </Menu>
      {/* Button */}
      <Button
        onClick={(e) => setAnchorMenu(e.currentTarget)}
        variant="contained"
        color="primary"
        size="small"
        sx={{
          boxShadow: "none",
          color: "common.white",
          textTransform: "none",
          "&:hover": { boxShadow: "none" },
        }}
        startIcon={<LuMoreVertical size={16} />}
      >
        Tùy chọn
      </Button>
    </>
  );
}

export default Options;
